import { styled, Tooltip } from "@mui/material";

export const TooltipStyled = styled(Tooltip)(({ theme }) => ({

}))

export const TooltipIcon = styled('span')(({ theme }) => ({
  display: "inline-block",
  marginLeft: theme.spacing(0.5),
  verticalAlign: "middle",
  transform: `translateY(1px)`
}))